import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import moment from "moment";

import { IconButton, Stack, Typography } from "@mui/material";
import CustomRightDrawer from "components/atoms/CustomRightDrawer";
import Pagination from "components/molecules/pagination/Pagination";
import MediceDetailsModal from "pages/pharmacy/components/MedicineDetails";
import { currencyFormatter } from "utils/numberFormatter";

const getIssuer = (row) =>
  (row?.pharmacist?.fullName || row?.nurse?.fullName || "").trim() || "N/A";

const Row = ({ i, toggleModal, row, offset }) => {
  const items = row?.items || [];

  return (
    <TableRow
      sx={{
        "&:nth-of-type(odd)": {
          backgroundColor: "background.custom",
        },
        "&:last-child td, &:last-child th": { border: 0 },
        verticalAlign: "top",
      }}
    >
      <TableCell component="th" scope="row" align="left" sx={{ width: "70px" }}>
        {offset + i + 1}
      </TableCell>

      <TableCell align="left">{row?.uniqueCode}</TableCell>

      <TableCell align="left">
        {row?.dispensedDate
          ? moment(row.dispensedDate).format("MMM D, YYYY h:mm A")
          : "N/A"}
      </TableCell>

      <TableCell align="left">{`${row?.patient?.firstName || ""} ${
        row?.patient?.lastName || ""
      }`}</TableCell>

      {/* Medication name(s) - one line per item */}
      <TableCell align="left">
        <Stack spacing={0.5}>
          {items.length
            ? items.map((item, idx) => (
                <Typography key={item?.product?._id || idx} variant="body2">
                  {item?.product?.drugName || "N/A"}
                </Typography>
              ))
            : "N/A"}
        </Stack>
      </TableCell>

      {/* Quantity - lines up with the medication on the same row */}
      <TableCell align="left">
        <Stack spacing={0.5}>
          {items.length
            ? items.map((item, idx) => (
                <Typography key={item?.product?._id || idx} variant="body2">
                  {item?.quantity ?? "N/A"}
                </Typography>
              ))
            : "N/A"}
        </Stack>
      </TableCell>

      <TableCell align="left">{getIssuer(row)}</TableCell>

      <TableCell align="left">{currencyFormatter(row?.totalCost)}</TableCell>

      <TableCell align="left">
        <IconButton
          color="secondary"
          disableRipple
          sx={{
            fontSize: "14px",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
          onClick={() => toggleModal(row)}
        >
          View
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

const headers = [
  "S/N",
  "Request Number",
  "Dispense Date",
  "Patient Name",
  "Medication Name",
  "Quantity",
  "Issued By",
  "Sales Price",
  "Action",
];

export default function DispenseHistoryTable({
  data,
  currentPage,
  handlePageChange,
}) {
  const modalRef = React.useRef(null);
  const [details, setdetails] = React.useState(null);
  const toggleModal = (item) => {
    setdetails(item);
    modalRef?.current?.handleToggle();
  };
  const pageSize = 10;
  const offset = ((currentPage || 1) - 1) * pageSize;

  return (
    <>
      {data?.prescriptions?.length ? (
        <>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 1000 }} aria-label="dispense history table">
              <TableHead>
                <TableRow>
                  {headers.map((h) => (
                    <TableCell
                      key={h}
                      align="left"
                      sx={{ fontWeight: "bold" }}
                    >
                      {h}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.prescriptions.map((row, i) => (
                  <Row
                    key={row?._id}
                    row={row}
                    toggleModal={toggleModal}
                    i={i}
                    offset={offset}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Pagination
            currentPage={currentPage}
            totalCount={data?.count || 5}
            pageSize={pageSize}
            activeColor="secondary.main"
            onPageChange={handlePageChange}
          />
        </>
      ) : (
        "No data found"
      )}

      <CustomRightDrawer ref={modalRef} title={"Medicine Details"} subTitle="">
        <MediceDetailsModal details={details} />
      </CustomRightDrawer>
    </>
  );
}